import React from 'react'
import './CSS/Aboutus.css'


function Aboutus() {
  return (
	<body class="aboutus-body">
	<section class="aboutus-section">
	  <div class = "aboutus-content">
			<h2>About Us</h2>
			<p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis aspernatur voluptas inventore ab voluptates nostrum minus illo laborum harum laudantium earum ut, temporibus fugiat sequi explicabo facilis unde quos corporis!

			Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis aspernatur voluptas inventore ab voluptates nostrum minus illo laborum harum laudantium earum ut, temporibus fugiat sequi explicabo facilis unde quos corporis!

			</p>
		   
			<ul class = "aboutus-icons">
				<li>
					<i class = "fa fa-twitter"></i>
				</li>
				<li>
					<i class = "fa fa-facebook"></i>
				</li>
				<li>
					<i class = "fa fa-github"></i>
				</li>
				<li>
					<i class = "fa fa-pinterest"></i>
				</li>
			</ul>
			 
		</div>
		<div class="aboutus-image">
		<div class = "aboutus-image1">
		  <img src="https://images.pexels.com/photos/9507678/pexels-photo-9507678.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"/>
	   </div>
	   <div class = "aboutus-image2">
		<img src="https://images.pexels.com/photos/9542697/pexels-photo-9542697.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"/>
	 </div>
	 <div class = "aboutus-image3">
		<img src="https://images.pexels.com/photos/11432840/pexels-photo-11432840.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"/>
	 </div>
	 <div class = "aboutus-image4">
		<img src="https://images.pexels.com/photos/2531236/pexels-photo-2531236.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"/>
	 </div>

	</div>
</section> 
	<br/><br/>
	
</body>
  )
}
export default Aboutus